import { useState } from 'react';
import { toast } from 'react-toastify';
import UseContext from 'hooks/useContext';
import useModal from 'components/modal/useModal';
import ApiDatabase from 'server';
import Button from 'components/button';
import ModalBody from 'components/modal/components/body';
import ModalFooter from 'components/modal/components/footer';
import Modalheader from 'components/modal/components/header';

/**
 * Confirming what an admin is about to do to a prolongation request
 * (JBWEB-1209).
 *
 * One component, three modals: the three designs differ only in their wording,
 * and the consequence of each — which is the whole point of asking — is what
 * the text has to get right.
 */
const ACTIONS = {
  accepted: {
    title: 'Accepter la demande de prolongation',
    // Said plainly because it is what the confirmation is for: accepting moves
    // the mission's dates and sends an avenant to BeSTT.
    description:
      'Êtes-vous sûr d’accepter la demande de prolongation de cette mission ? Les dates de la mission seront mises à jour et un avenant sera généré.',
    confirmLabel: 'Confirmer',
    success: 'La demande de prolongation a été acceptée',
  },
  refused: {
    title: 'Refuser la demande de prolongation',
    description:
      'Êtes-vous sûr de refuser la demande de prolongation de cette mission ? Les dates de la mission resteront inchangées.',
    confirmLabel: 'Confirmer',
    success: 'La demande de prolongation a été refusée',
  },
  cancelled: {
    title: 'Annuler la demande de prolongation',
    description:
      'Êtes-vous sûr d’annuler la demande de prolongation de cette mission ? Les modifications de dates seront perdues.',
    confirmLabel: 'Confirmer',
    success: 'La demande de prolongation a été annulée',
  },
};

const ModalAmendmentRequestAction = () => {
  const { toggle } = useModal();
  const { modalData, setModalDataReturn } = UseContext();
  const [isLoading, setIsLoading] = useState(false);
  const token = localStorage.getItem('xsrfToken');

  const action = ACTIONS[modalData?.action] ?? ACTIONS.cancelled;

  const confirm = () => {
    if (isLoading) return;
    setIsLoading(true);

    ApiDatabase.postAmendmentRequestAction(
      {
        token,
        idRequest: modalData?.idRequest,
        action: modalData?.action,
      },
      () => {
        setIsLoading(false);
        toast.success(action.success);
        // The page reloads the mission rather than patching the card: accepting
        // also moves dates and adds an avenant, so half the screen is stale.
        setModalDataReturn({ type: 'amendment_request_actioned' });
        toggle();
      },
      (err) => {
        setIsLoading(false);
        if (err.name === 'CanceledError') return;
        toast.error(
          err?.response?.data?.message ?? "L'action n'a pas pu être effectuée"
        );
      }
    );
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        {action.title}
      </Modalheader>
      <ModalBody>
        <div className={'text-gray-500'}>{action.description}</div>
      </ModalBody>
      <ModalFooter>
        <Button size={'LG'} color={'SECONDARY'} onClick={toggle}>
          Annuler
        </Button>
        <Button
          size={'LG'}
          color={isLoading ? 'DISABLED' : 'PRIMARY'}
          onClick={isLoading ? undefined : confirm}
        >
          {isLoading ? 'Confirmation ...' : action.confirmLabel}
        </Button>
      </ModalFooter>
    </>
  );
};

export default ModalAmendmentRequestAction;
